'use client';

import { useContext } from 'react';
import { TourContext } from '../context/TourContext';
import type { TourContextValue } from '../types';

const NOOP = () => {};
const EMPTY_SET = new Set<never>();

/** Stable defaults when TourProvider is not mounted */
const DEFAULT_VALUE: TourContextValue = {
  isActive: false,
  activeTourId: null,
  currentStepIndex: 0,
  currentStep: null,
  completedSteps: EMPTY_SET,
  nextStep: NOOP,
  completeTour: NOOP,
  startTour: NOOP,
};

/**
 * Hook to access the tour state and actions.
 *
 * Must be used within a TourProvider. Returns safe defaults
 * if the provider is not found (tour inactive).
 */
export function useTour(): TourContextValue {
  const context = useContext(TourContext);
  return context ?? DEFAULT_VALUE;
}
